import { useState } from "react";
import MeetingReview from "./MeetingReview";
import BankBalanceReview from "./BankBalanceReview";
import EcoTourismReview from "./EcoTourismReview";
import AuditRenewalReview from "./AuditRenewalReview";
import MonthlyLoanReview from "./MonthlyLoanReview";
import MonthlyLoanRecoveryReview from "./MonthlyLoanRecoveryReview"

const TABS = [
  {
    key: "Monthly Meeting Progress",
    label: "Meetings",
    icon: "mdi-calendar-check",
    color: "#2E7D32",
  },
  {
    key: "Monthly Bank Balance",
    label: "Bank Balance",
    icon: "mdi-bank",
    color: "#1565C0",
  },
  {
    key: "Eco-Tourism Review",
    label: "Eco Tourism",
    icon: "mdi-pine-tree",
    color: "#EF6C00",
  },
  {
    key: "Audit & Renewal Review",
    label: "Audit & Renewal",
    icon: "mdi-file-multiple",
    color: "#5c00ef",
  },
  {
    key: "Loan Review",
    label: "Loan Review",
    icon: "mdi-cash-multiple",
    color: "#005792",
  },
  {
    key: "Loan Recovery Review",
    label: "Loan Recovery Review",
    icon: "mdi-cash-multiple",
    color: "#ae00ff",
  },
];


const ReviewDashboard = () => {
  const [key, setKey] = useState("Monthly Meeting Progress");

  return (
    <div style={{ padding: 20 }}>

      {/* Header */}
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          padding: "22px 28px",
          marginBottom: 25,
          border: "1px solid #E2E8F0",
          boxShadow: "0 6px 18px rgba(15,23,42,.06)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 20,
          }}
        >
          <div>
            <h3
              style={{
                margin: 0,
                fontWeight: 700,
                color: "#1E293B",
              }}
            >
              Monthly Review Dashboard
            </h3>

            <p
              style={{
                marginTop: 6,
                marginBottom: 0,
                color: "#64748B",
                fontSize: 13,
              }}
            >
              Monitor Meetings, Bank Balance and Eco-Tourism progress across
              all JFMCs.
            </p>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              color: "#64748B",
              fontSize: 13,
            }}
          >
            <i className="mdi mdi-home-outline" />
            Dashboard
            <i className="mdi mdi-chevron-right" />
            Monthly Review
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div
        style={{
          display: "flex",
          gap: 16,
          flexWrap: "wrap",
          marginBottom: 25,
        }}
      >
        {TABS.map((tab) => {
          const active = key === tab.key;

          return (
            <div
              key={tab.key}
              onClick={() => setKey(tab.key)}
              style={{
                cursor: "pointer",
                flex: "1 1 250px",
                minWidth: 230,
                borderRadius: 16,
                padding: 18,
                background: active ? tab.color : "#fff",
                color: active ? "#fff" : "#1E293B",
                border: active
                  ? `2px solid ${tab.color}`
                  : "1px solid #E2E8F0",
                boxShadow: active
                  ? "0 12px 25px rgba(0,0,0,.15)"
                  : "0 2px 10px rgba(0,0,0,.05)",
                transition: ".25s",
              }}
            >
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 14,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 14,
                  background: active
                    ? "rgba(255,255,255,.18)"
                    : `${tab.color}15`,
                }}
              >
                <i
                  className={`mdi ${tab.icon}`}
                  style={{
                    fontSize: 26,
                    color: active ? "#fff" : tab.color,
                  }}
                />
              </div>

              <div
                style={{
                  fontWeight: 700,
                  fontSize: 15,
                  marginBottom: 5,
                }}
              >
                {tab.label}
              </div>

              <div
                style={{
                  fontSize: 12,
                  opacity: active ? 0.9 : 0.6,
                }}
              >
                View monthly progress
              </div>
            </div>
          );
        })}
      </div>

      {/* Content */}
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          padding: 20,
          border: "1px solid #E2E8F0",
          boxShadow: "0 4px 18px rgba(15,23,42,.05)",
        }}
      >
        {key === "Monthly Meeting Progress" && <MeetingReview />}
        {key === "Monthly Bank Balance" && <BankBalanceReview />}
        {key === "Eco-Tourism Review" && <EcoTourismReview />}
        {key === "Audit & Renewal Review" && <AuditRenewalReview />}
        {key === "Loan Review" && <MonthlyLoanReview />}
        {key === "Loan Recovery Review" && <MonthlyLoanRecoveryReview />}


      </div>
    </div>
  );
};

export default ReviewDashboard;